import {useEffect, useState} from 'react'
import {Col, Form, Modal, Row} from 'react-bootstrap'
import {BiAlarmExclamation, BiInfoCircle, BiInfoSquare} from 'react-icons/bi'
import {BsFillExclamationCircleFill} from 'react-icons/bs'
// import  from 'react-bootstrap/Row'
type Props = {
  terreno: any
}

export const ModalInfo: React.FC<Props> = ({terreno}) => {
  const [show, setShow] = useState(false)
  const [showButton, setShowButton] = useState(false)

  useEffect(() => {
    if (terreno) {
      if (
        terreno.operacao_urbana ||
        terreno.contaminacao ||
        terreno.desapropriacao ||
        terreno.melhoramento_viario ||
        terreno.patrimonio_cultural
      ) {
        setShowButton(true)
      }
    }
  }, [terreno])

  function closeModal() {
    setShow(false)
  }

  function showModal() {
    setShow(true)
  }
  return (
    <>
      {showButton ? (
        <button className='btn' type='button' onClick={showModal}>
          <BsFillExclamationCircleFill className='text-danger fs-1'></BsFillExclamationCircleFill>
        </button>
      ) : (
        <></>
      )}
      <Modal centered animation show={show} onHide={() => closeModal()}>
        <Modal.Header closeButton>
          <Modal.Title>Alertas</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row} className='mb-3' controlId='formPlaintextEmail'>
              {terreno.operacao_urbana ? (
                <>
                  <Form.Label column sm='3'>
                    Operação Urbana
                  </Form.Label>
                  <Col sm='9'>
                    <Form.Control plaintext readOnly defaultValue={terreno.operacao_urbana || ''} />
                  </Col>
                </>
              ) : (
                <></>
              )}
              {terreno.contaminacao ? (
                <>
                  <Form.Label column sm='3'>
                    Contaminação
                  </Form.Label>
                  <Col sm='9'>
                    <Form.Control plaintext readOnly defaultValue={terreno.contaminacao || ''} />
                  </Col>
                </>
              ) : (
                <></>
              )}
              {terreno.desapropriacao ? (
                <>
                  <Form.Label column sm='3'>
                    Desapropriacao
                  </Form.Label>
                  <Col sm='9'>
                    <Form.Control plaintext readOnly defaultValue={terreno.desapropriacao || ''} />
                  </Col>
                </>
              ) : (
                <></>
              )}
              {terreno.melhoramento_viario ? (
                <>
                  <Form.Label column sm='3'>
                    Melhoramento Viário
                  </Form.Label>
                  <Col sm='9'>
                    <Form.Control
                      plaintext
                      readOnly
                      defaultValue={terreno.melhoramento_viario || ''}
                    />
                  </Col>
                </>
              ) : (
                <></>
              )}
              {terreno.patrimonio_cultural ? (
                <>
                  <Form.Label column sm='3'>
                    Patrimônio Cultural
                  </Form.Label>
                  <Col sm='9'>
                    <Form.Control
                      plaintext
                      readOnly
                      defaultValue={terreno.patrimonio_cultural || ''}
                    />
                  </Col>
                </>
              ) : (
                <></>
              )}
            </Form.Group>
          </Form>

          {/* <Loader text={'caregando...'}></Loader> */}
        </Modal.Body>
      </Modal>
    </>
  )
}
